import React from "react";
import {
  BiLogoFacebookCircle,
  BiLogoInstagramAlt,
  BiSolidEnvelope,
} from "react-icons/bi";
import { RiWhatsappFill } from "react-icons/ri";
import { Contacto } from "../Contacto/Contacto";
import "./Footer.css";

export const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-top">
        <p className="footer-top--text">VERDIVIA</p>
        <p className="footer-top--subtitle">Identidad Mendocina</p>
        <div className="footer-top--right">
          <p className="footer-top--right-text">Seguinos</p>
          <a
            href="https://www.facebook.com/people/verdiviamza/100069458418428/"
            target="_blank"
            rel="noreferrer"
          >
            <BiLogoFacebookCircle className="footer-top--icons" />
          </a>
          <a
            href="https://www.instagram.com/verdivia.mza/"
            target="_blank"
            rel="noreferrer"
          >
            <BiLogoInstagramAlt className="footer-top--icons" />
          </a>
        </div>
      </div>
      <div className="footer-middle">
        <a className="footer-middle--link" href="#quienessomos">
          Quiénes somos
        </a>
        <a className="footer-middle--link" href="#ubicacion">
          Dónde encontrarnos
        </a>
        <div className="footer-middle--link-container">
          <RiWhatsappFill className="footer-middle--link-icon" />

          <a
            className="footer-middle--link"
            href="https://walink.co/b0dde0"
            target="_blank"
            rel="noreferrer"
          >
            Whatsapp de contacto
          </a>
        </div>
        <a className="footer-middle--link" href="#productos">
          Nuestros productos
        </a>
        <a className="footer-middle--link" href="#preguntas">
          Preguntas frecuentes
        </a>
        <div className="footer-middle--link-container">
          <BiSolidEnvelope className="footer-middle--link-icon" />
          <Contacto
            text="Mail de contacto"
            className="footer-middle--link-contactos"
          />
        </div>
      </div>
      <div className="footer-middle-mobile">
        <Contacto className="footer-middle-mobile--link-contactos" />
        <a
          className="footer-middle--link"
          href="https://walink.co/b0dde0"
          target="_blank"
          rel="noreferrer"
        >
          <RiWhatsappFill className="footer-middle--link-icon" />
        </a>
      </div>
      <hr className="footer-separation" />
      <div className="footer-bottom">
        <p className="footer-bottom--text">
          Verdivia - Todos los derechos reservados © 2023
        </p>
      </div>
    </footer>
  );
};
